export const de = {
  returnLineItems: {
    refund: "Rückerstattung(en)",
    exchange: "Umtausch",
    discount: "Rabatt(e)",
  },
  returnStoreAddress: {
    mapButton: "Auf Karte anzeigen",
  },
  returnRequestDate: {
    label: "Ihre Rücksendeanfrage wurde am {{date}} um {{time}} Uhr gestellt",
  },
  actions: {
    continue: "Weiter",
  },
  "order-identification": {
    title: "Verfolgen Sie Ihre Bestellung",
    description: "Geben Sie Ihre Bestelldetails ein, um Ihr Paket zu verfolgen",
    fields: {
      "zip-code": {
        title: "Postleitzahl",
        description: "Geben Sie Ihre Lieferpostleitzahl ein",
        required: "Die Postleitzahl ist erforderlich",
      },
      email: {
        title: "E-Mail-Adresse",
        description: "Geben Sie die für Ihre Bestellung verwendete E-Mail-Adresse ein",
        required: "E-Mail-Adresse ist erforderlich",
      },
      both: {
        title: "Postleitzahl oder E-Mail",
        description: "Geben Sie Ihre Liefer-Postleitzahl oder die für Ihre Bestellung verwendete E-Mail ein",
        required: "Postleitzahl oder E-Mail ist erforderlich",
      },
      "tracking-number": {
        title: "Bestellnummer",
        description: "Geben Sie Ihre Bestellnummer ein",
        required: "Die Bestellnummer ist erforderlich",
      },
    },
    errors: {
      "unknown-order": {
        title: "Unbekannte Bestellnummer",
        description:
          "Die Bestellnummer wurde nicht gefunden, bitte überprüfen Sie sie",
      },
      "search-error": {
        title: "Suchfehler",
        description:
          "Wir konnten die Bestellung nicht finden. Bitte versuchen Sie es später erneut.",
      },
    },
  },
  delivery: "Lieferung",
  "parcel-history": "Paketverlauf",
  "order-details": {
    title: "Bestelldetails",
    "tracking-number": "Sendungsnummer",
    "order-number": "Bestellnummer",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Voraussichtliches Lieferdatum",
      deliveredOn: "Geliefert am",
      from: "vom",
      to: "bis",
    },
  },
  deliveryAddress: {
    title: "Lieferadresse:",
    titlePickup: "Adresse der Abholstelle:",
    orderDetails: {
      title: "Bestelldetails:",
      trackingNumber: "Sendungsnummer:",
      orderNumber: "Bestellnummer:",
      orderDate: "Bestelldatum:",
    },
  },
  pickupPoint: {
    title: "Abholstation",
    openingHours: "Öffnungszeiten:",
    closed: "Geschlossen",
    directions: "Wegbeschreibung",
    days: {
      monday: "Montag:",
      tuesday: "Dienstag:",
      wednesday: "Mittwoch:",
      thursday: "Donnerstag:",
      friday: "Freitag:",
      saturday: "Samstag:",
      sunday: "Sonntag:",
    },
  },
  wallet: {
    warningNotEnabled:
      "Sie müssen Wallet in Ihren Shop-Einstellungen aktivieren",
  },
  crossSell: {
    youMightAlsoLike: "Das könnte Ihnen auch gefallen",
  },
  "rate-order": {
    "order-recap": {
      title: "Ihre Bestellung",
      "tracking-label": "Sendungsnummer:",
      "order-label": "Bestellnummer:",
    },
    form: {
      title: "Bewerten Sie Ihre Lieferung",
      "rating-label": "Bewerten Sie Ihre Liefererfahrung",
      "comment-label": "Kommentar (optional)",
      "comment-placeholder": "Teilen Sie uns Ihre Erfahrung mit…",
      "submit-cta": "Bewertung absenden",
      "update-cta": "Bewertung aktualisieren",
      "rating-required": "Bitte wählen Sie eine Bewertung aus.",
    },
    "thank-you": {
      title: "Vielen Dank für Ihr Feedback!",
      description:
        "Ihre Bewertung wurde gespeichert. Sie hilft uns, die Liefererfahrung zu verbessern.",
    },
    errors: {
      "invalid-token": {
        title: "Ungültiger oder abgelaufener Link",
        description:
          "Dieser Link ist nicht mehr gültig. Bitte öffnen Sie ihn erneut aus Ihrer letzten Tracking-E-Mail.",
      },
      submit: {
        title: "Etwas ist schiefgelaufen",
        description:
          "Wir konnten Ihre Bewertung nicht speichern. Bitte versuchen Sie es später erneut.",
      },
    },
  },
  shippingInstructions: {
    colissimo:
      "Sie können jetzt Ihr Rücksendeetikett ausdrucken und Ihr Paket beim nächstgelegenen Colissimo-Relaispunkt abgeben.",
    chronoShop2Shop:
      "Sie können jetzt Ihr Rücksendeetikett ausdrucken und Ihr Paket beim nächstgelegenen Chronopost-Relaispunkt abgeben.",
    ups: "Sie können jetzt Ihr Rücksendeetikett ausdrucken und Ihr Paket beim nächstgelegenen UPS-Relaispunkt abgeben.",
    customerCarrier:
      "Sie können nun Ihr Rücksendepaket an den Spediteur Ihrer Wahl senden.",
    merchantCarrier:
      "Wir senden Ihnen ein Rücksendeetikett per E-Mail innerhalb von 1 bis 3 Werktagen.",
    returnToStore:
      "Sie können jetzt Ihr Rücksendeetikett ausdrucken und Ihr Paket im nächstgelegenen Geschäft abgeben.",
    malca:
      "Sie können jetzt Ihr Rücksendeetikett ausdrucken und Ihr Paket beim nächstgelegenen Malca-Relaispunkt abgeben.",
    tnt: "Sie können jetzt Ihr Rücksendeetikett ausdrucken und Ihr Paket beim nächstgelegenen TNT-Relaispunkt abgeben.",
    bonDeRetour:
      "Ihr Rücksendeschein ist bereit. Sie können ihn jetzt ausdrucken und für Ihre Rücksendung verwenden.",
  },
  downloadLabel: {
    label: "Mein Etikett herunterladen",
    bonDeRetour: "Meinen Rücksendeschein herunterladen",
  },
  shippingInstructionsTitle: {
    shippingLabel: "Ihr Versandetikett ist bereit",
    bonDeRetour: "Ihr Rücksendeschein ist bereit",
  },
} as const;
